import { useMemo } from "react";
import dayjs from "@shared/dayjs";

const getTimeOptions = () => {
  const options = [];
  let startTime = dayjs().startOf("day");
  const endTime = dayjs().endOf("day");

  while (startTime.isBefore(endTime)) {
    options.push({ value: startTime.format("HH:mm:ss"), label: startTime.format("h:mm a") });
    startTime = startTime.add(15, "minute");
  }

  return options;
};

const useTimeOptions = () => useMemo(getTimeOptions, []);

export default useTimeOptions;
